import { useState } from 'react';

interface HelpTooltipProps {
  text: string;
  inline?: boolean;
}

/**
 * HelpTooltip — Fragezeichen-Button mit aufklappbarem Hilfetext.
 * Verwendet reine HTML-Elemente für maximale Kompatibilität.
 */
export default function HelpTooltip({ text, inline = false }: HelpTooltipProps) {
  const [open, setOpen] = useState(false);

  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setOpen(!open);
        }}
        style={{
          cursor: 'pointer',
          background: 'none',
          border: '1.5px solid var(--sapInformativeColor, #0070f2)',
          borderRadius: '50%',
          width: inline ? '16px' : '18px',
          height: inline ? '16px' : '18px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: '0.375rem',
          padding: 0,
          color: 'var(--sapInformativeColor, #0070f2)',
          fontSize: inline ? '10px' : '11px',
          fontWeight: 700,
          lineHeight: 1,
          opacity: open ? 1 : 0.7,
          transition: 'opacity 0.15s'
        }}
        onMouseEnter={(e) => { (e.target as HTMLElement).style.opacity = '1'; }}
        onMouseLeave={(e) => { if (!open) (e.target as HTMLElement).style.opacity = '0.7'; }}
        title="Hilfe anzeigen"
      >
        ?
      </button>
      {open && (
        <>
          <div
            onClick={() => setOpen(false)}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              zIndex: 999
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: '2rem',
              top: '-0.25rem',
              zIndex: 1000,
              background: 'white',
              border: '1px solid var(--sapGroup_ContentBorderColor, #d9d9d9)',
              borderLeft: '3px solid var(--sapInformativeColor, #0070f2)',
              borderRadius: '0.375rem',
              boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
              padding: '0.75rem 1rem',
              maxWidth: '420px',
              minWidth: '300px',
              lineHeight: '1.65',
              fontSize: '0.8125rem',
              color: '#333'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
              <span style={{ fontWeight: 700, color: 'var(--sapInformativeColor, #0070f2)', fontSize: '0.75rem' }}>HILFE</span>
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); setOpen(false); }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: '14px', padding: 0, lineHeight: 1 }}
              >
                ×
              </button>
            </div>
            {text.split('\n').map((line, i) => (
              <div
                key={i}
                style={{
                  marginBottom: line === '' ? '0.5rem' : '0.15rem',
                  paddingLeft: line.startsWith('•') ? '0.5rem' : '0',
                  whiteSpace: 'pre-wrap'
                }}
              >
                {line}
              </div>
            ))}
          </div>
        </>
      )}
    </span>
  );
}
